import React from 'react';
import { Form, Button, Typography, Checkbox } from 'antd';

const { Title, Text } = Typography;

const Step18 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(values => {
        next();
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={2}>Assistance Animals</Title>
      
      <Text>
        It is a condition of being a Opera Taxis Driver that a driver cannot refuse to transport a passenger with an assistance animal or an assistance animal in training.
      </Text>
      
      <Text>
        Assistance animals are trained to aid people with a disability. These assistance animals are not pets.
      </Text>
      
      <Text>
        Please ensure:
      </Text>
      <ul>
        <li>You don’t touch, talk, feed or otherwise distract the assistance animal.</li>
        <li>You do not treat the animal as a pet, give it the respect of a working animal.</li>
        <li>You do not speak to or give the animal any commands unless the passenger asks you to.</li>
        <li>You speak to the handler, not their assistance animal.</li>
      </ul>
      
      <Text>
        The assistance animals usually sit in the front passenger or rear footwell of the Taxi. The assistance animal does not need to be secured in the car and should never be separated from the passenger.
      </Text>
      
      <Text>
        <b>PLEASE NOTE:</b> DRIVERS CAN BE FINED UP TO $1,110.00 FOR REFUSING TO PICK UP A PASSENGER WITH ANY TYPE OF ASSISTANCE ANIMAL.
      </Text>
      
      <Text>
        For further information regarding assistance animals please see links below:
      </Text>
      <ul>
        <li>The Point to Point Transport (Taxis and hire Vehicles) Regulation 2017</li>
        <li>The Disability Discrimination Act 1992</li>
        <li>Office of Local Government</li>
        <li>Health Direct</li>
      </ul>

      <Form.Item
        name="understandAssistanceAnimal"
        valuePropName="checked"
        rules={[
          {
            required: true,
            message: 'You must acknowledge this condition to proceed.',
          },
        ]}
      >
        <Checkbox  onChange={(e) => {
      form.setFieldsValue({
        understandAssistanceAnimal: e.target.checked ? "agree" : undefined,
      });
    }}>
          I understand I cannot refuse passengers with assistance animals. *
        </Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step18;
